module.exports = __webpack_public_path__ + "static/media/audio-23.520bd40c.mp3";